import styled, { css } from 'styled-components';

import { media } from 'styles/utils';

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  ${media.tablet`
    min-height: 100%;
  `}
`;

export const Header = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 5;
`;

export const Content = styled.div<ContentProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  padding: 0 0 89px;
  background-color: ${({ theme }) => theme.colors.turquoise.light};

  ${({ dark, theme }) => dark && css`
    background-color: ${theme.colors.turquoise};
  `}

  ${({ backgroundImage, theme }) => backgroundImage && css`
    background: linear-gradient(185.74deg, rgba(0, 0, 0, 0) 45.08%, rgba(0, 0, 0, 0.25) 85.75%),
      url('${backgroundImage}'), ${theme.colors.white};
    background-size: cover;
    background-position: center 5vh;

    ${media.desktop`
      background-position: center -20%;
    `}
  `}

  ${({ noFooter }) => noFooter && css`
    padding: 0;
  `}

  ${({ center }) => center === false && css`
    justify-content: flex-start;
  `}

  ${media.desktop`
    justify-content: center;
  `}
`;

type ContentProps = {
  backgroundImage?: string;
  dark?: boolean;
  noFooter?: boolean;
  center?: boolean;
};
